<template>
  <div style="margin-bottom: 16px">
    <div style="font-size: 18px; font-weight: 300;">{{item.itemName}}</div>
    <div style="margin-left: 72px"><b>Descripcion:</b> {{item.description}}</div>
    <div style="margin-left: 72px"><b>Labels:</b> {{item.labels}}</div>
    <div style="margin-left: 72px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" ><b>Vista previa:</b> {{item.imageUrl}}</div>
  </div>
</template>

<script>
export default {
  name: 'flat-structure-item',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/structures/flat-structure-item.vue